import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import media from './media'
/**
* @see \App\Http\Controllers\Admin\ListingListController::index
* @see app/Http/Controllers/Admin/ListingListController.php:30
* @route '/admin/listings'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/listings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ListingListController::index
* @see app/Http/Controllers/Admin/ListingListController.php:30
* @route '/admin/listings'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ListingListController::index
* @see app/Http/Controllers/Admin/ListingListController.php:30
* @route '/admin/listings'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ListingListController::index
* @see app/Http/Controllers/Admin/ListingListController.php:30
* @route '/admin/listings'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ListingListController::index
* @see app/Http/Controllers/Admin/ListingListController.php:30
* @route '/admin/listings'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ListingListController::index
* @see app/Http/Controllers/Admin/ListingListController.php:30
* @route '/admin/listings'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ListingListController::index
* @see app/Http/Controllers/Admin/ListingListController.php:30
* @route '/admin/listings'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\ListingListController::exportMethod
* @see app/Http/Controllers/Admin/ListingListController.php:47
* @route '/admin/listings/export'
*/
export const exportMethod = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

exportMethod.definition = {
    methods: ["get","head"],
    url: '/admin/listings/export',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ListingListController::exportMethod
* @see app/Http/Controllers/Admin/ListingListController.php:47
* @route '/admin/listings/export'
*/
exportMethod.url = (options?: RouteQueryOptions) => {
    return exportMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ListingListController::exportMethod
* @see app/Http/Controllers/Admin/ListingListController.php:47
* @route '/admin/listings/export'
*/
exportMethod.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ListingListController::exportMethod
* @see app/Http/Controllers/Admin/ListingListController.php:47
* @route '/admin/listings/export'
*/
exportMethod.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: exportMethod.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ListingListController::exportMethod
* @see app/Http/Controllers/Admin/ListingListController.php:47
* @route '/admin/listings/export'
*/
const exportMethodForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ListingListController::exportMethod
* @see app/Http/Controllers/Admin/ListingListController.php:47
* @route '/admin/listings/export'
*/
exportMethodForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ListingListController::exportMethod
* @see app/Http/Controllers/Admin/ListingListController.php:47
* @route '/admin/listings/export'
*/
exportMethodForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

exportMethod.form = exportMethodForm

/**
* @see \App\Http\Controllers\Admin\ListingEditController::edit
* @see app/Http/Controllers/Admin/ListingEditController.php:56
* @route '/admin/listings/{listing}/edit'
*/
export const edit = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/admin/listings/{listing}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ListingEditController::edit
* @see app/Http/Controllers/Admin/ListingEditController.php:56
* @route '/admin/listings/{listing}/edit'
*/
edit.url = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { listing: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { listing: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            listing: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        listing: typeof args.listing === 'object'
        ? args.listing.id
        : args.listing,
    }

    return edit.definition.url
            .replace('{listing}', parsedArgs.listing.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ListingEditController::edit
* @see app/Http/Controllers/Admin/ListingEditController.php:56
* @route '/admin/listings/{listing}/edit'
*/
edit.get = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ListingEditController::edit
* @see app/Http/Controllers/Admin/ListingEditController.php:56
* @route '/admin/listings/{listing}/edit'
*/
edit.head = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ListingEditController::edit
* @see app/Http/Controllers/Admin/ListingEditController.php:56
* @route '/admin/listings/{listing}/edit'
*/
const editForm = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ListingEditController::edit
* @see app/Http/Controllers/Admin/ListingEditController.php:56
* @route '/admin/listings/{listing}/edit'
*/
editForm.get = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ListingEditController::edit
* @see app/Http/Controllers/Admin/ListingEditController.php:56
* @route '/admin/listings/{listing}/edit'
*/
editForm.head = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\ListingEditController::update
* @see app/Http/Controllers/Admin/ListingEditController.php:83
* @route '/admin/listings/{listing}'
*/
export const update = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/admin/listings/{listing}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\ListingEditController::update
* @see app/Http/Controllers/Admin/ListingEditController.php:83
* @route '/admin/listings/{listing}'
*/
update.url = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { listing: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { listing: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            listing: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        listing: typeof args.listing === 'object'
        ? args.listing.id
        : args.listing,
    }

    return update.definition.url
            .replace('{listing}', parsedArgs.listing.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ListingEditController::update
* @see app/Http/Controllers/Admin/ListingEditController.php:83
* @route '/admin/listings/{listing}'
*/
update.put = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\ListingEditController::update
* @see app/Http/Controllers/Admin/ListingEditController.php:83
* @route '/admin/listings/{listing}'
*/
const updateForm = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ListingEditController::update
* @see app/Http/Controllers/Admin/ListingEditController.php:83
* @route '/admin/listings/{listing}'
*/
updateForm.put = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\ListingEditController::situation
* @see app/Http/Controllers/Admin/ListingEditController.php:126
* @route '/admin/listings/{listing}/situation'
*/
export const situation = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: situation.url(args, options),
    method: 'patch',
})

situation.definition = {
    methods: ["patch"],
    url: '/admin/listings/{listing}/situation',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\ListingEditController::situation
* @see app/Http/Controllers/Admin/ListingEditController.php:126
* @route '/admin/listings/{listing}/situation'
*/
situation.url = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { listing: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { listing: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            listing: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        listing: typeof args.listing === 'object'
        ? args.listing.id
        : args.listing,
    }

    return situation.definition.url
            .replace('{listing}', parsedArgs.listing.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ListingEditController::situation
* @see app/Http/Controllers/Admin/ListingEditController.php:126
* @route '/admin/listings/{listing}/situation'
*/
situation.patch = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: situation.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\ListingEditController::situation
* @see app/Http/Controllers/Admin/ListingEditController.php:126
* @route '/admin/listings/{listing}/situation'
*/
const situationForm = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: situation.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ListingEditController::situation
* @see app/Http/Controllers/Admin/ListingEditController.php:126
* @route '/admin/listings/{listing}/situation'
*/
situationForm.patch = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: situation.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

situation.form = situationForm

/**
* @see \App\Http\Controllers\Admin\ListingEditController::galleryOrder
* @see app/Http/Controllers/Admin/ListingEditController.php:165
* @route '/admin/listings/{listing}/gallery-order'
*/
export const galleryOrder = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: galleryOrder.url(args, options),
    method: 'put',
})

galleryOrder.definition = {
    methods: ["put"],
    url: '/admin/listings/{listing}/gallery-order',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\ListingEditController::galleryOrder
* @see app/Http/Controllers/Admin/ListingEditController.php:165
* @route '/admin/listings/{listing}/gallery-order'
*/
galleryOrder.url = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { listing: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { listing: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            listing: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        listing: typeof args.listing === 'object'
        ? args.listing.id
        : args.listing,
    }

    return galleryOrder.definition.url
            .replace('{listing}', parsedArgs.listing.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ListingEditController::galleryOrder
* @see app/Http/Controllers/Admin/ListingEditController.php:165
* @route '/admin/listings/{listing}/gallery-order'
*/
galleryOrder.put = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: galleryOrder.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\ListingEditController::galleryOrder
* @see app/Http/Controllers/Admin/ListingEditController.php:165
* @route '/admin/listings/{listing}/gallery-order'
*/
const galleryOrderForm = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: galleryOrder.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ListingEditController::galleryOrder
* @see app/Http/Controllers/Admin/ListingEditController.php:165
* @route '/admin/listings/{listing}/gallery-order'
*/
galleryOrderForm.put = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: galleryOrder.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

galleryOrder.form = galleryOrderForm

/**
* @see \App\Http\Controllers\ListingController::destroy
* @see app/Http/Controllers/ListingController.php:218
* @route '/admin/listings/{listing}'
*/
export const destroy = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/listings/{listing}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ListingController::destroy
* @see app/Http/Controllers/ListingController.php:218
* @route '/admin/listings/{listing}'
*/
destroy.url = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { listing: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { listing: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            listing: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        listing: typeof args.listing === 'object'
        ? args.listing.id
        : args.listing,
    }

    return destroy.definition.url
            .replace('{listing}', parsedArgs.listing.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListingController::destroy
* @see app/Http/Controllers/ListingController.php:218
* @route '/admin/listings/{listing}'
*/
destroy.delete = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ListingController::destroy
* @see app/Http/Controllers/ListingController.php:218
* @route '/admin/listings/{listing}'
*/
const destroyForm = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ListingController::destroy
* @see app/Http/Controllers/ListingController.php:218
* @route '/admin/listings/{listing}'
*/
destroyForm.delete = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\ListingController::statusData
* @see app/Http/Controllers/ListingController.php:387
* @route '/admin/listings/{listing}/status-data'
*/
export const statusData = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statusData.url(args, options),
    method: 'get',
})

statusData.definition = {
    methods: ["get","head"],
    url: '/admin/listings/{listing}/status-data',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ListingController::statusData
* @see app/Http/Controllers/ListingController.php:387
* @route '/admin/listings/{listing}/status-data'
*/
statusData.url = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { listing: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { listing: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            listing: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        listing: typeof args.listing === 'object'
        ? args.listing.id
        : args.listing,
    }

    return statusData.definition.url
            .replace('{listing}', parsedArgs.listing.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListingController::statusData
* @see app/Http/Controllers/ListingController.php:387
* @route '/admin/listings/{listing}/status-data'
*/
statusData.get = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statusData.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingController::statusData
* @see app/Http/Controllers/ListingController.php:387
* @route '/admin/listings/{listing}/status-data'
*/
statusData.head = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: statusData.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ListingController::statusData
* @see app/Http/Controllers/ListingController.php:387
* @route '/admin/listings/{listing}/status-data'
*/
const statusDataForm = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statusData.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingController::statusData
* @see app/Http/Controllers/ListingController.php:387
* @route '/admin/listings/{listing}/status-data'
*/
statusDataForm.get = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statusData.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ListingController::statusData
* @see app/Http/Controllers/ListingController.php:387
* @route '/admin/listings/{listing}/status-data'
*/
statusDataForm.head = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: statusData.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

statusData.form = statusDataForm

/**
* @see \App\Http\Controllers\ListingController::updateStatus
* @see app/Http/Controllers/ListingController.php:414
* @route '/admin/listings/{listing}/status'
*/
export const updateStatus = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateStatus.url(args, options),
    method: 'patch',
})

updateStatus.definition = {
    methods: ["patch"],
    url: '/admin/listings/{listing}/status',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\ListingController::updateStatus
* @see app/Http/Controllers/ListingController.php:414
* @route '/admin/listings/{listing}/status'
*/
updateStatus.url = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { listing: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { listing: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            listing: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        listing: typeof args.listing === 'object'
        ? args.listing.id
        : args.listing,
    }

    return updateStatus.definition.url
            .replace('{listing}', parsedArgs.listing.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListingController::updateStatus
* @see app/Http/Controllers/ListingController.php:414
* @route '/admin/listings/{listing}/status'
*/
updateStatus.patch = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateStatus.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\ListingController::updateStatus
* @see app/Http/Controllers/ListingController.php:414
* @route '/admin/listings/{listing}/status'
*/
const updateStatusForm = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateStatus.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ListingController::updateStatus
* @see app/Http/Controllers/ListingController.php:414
* @route '/admin/listings/{listing}/status'
*/
updateStatusForm.patch = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateStatus.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updateStatus.form = updateStatusForm

/**
* @see \App\Http\Controllers\ReviewController::reviews
* @see app/Http/Controllers/ReviewController.php:60
* @route '/admin/listings/{listing}/reviews'
*/
export const reviews = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reviews.url(args, options),
    method: 'get',
})

reviews.definition = {
    methods: ["get","head"],
    url: '/admin/listings/{listing}/reviews',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ReviewController::reviews
* @see app/Http/Controllers/ReviewController.php:60
* @route '/admin/listings/{listing}/reviews'
*/
reviews.url = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { listing: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { listing: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            listing: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        listing: typeof args.listing === 'object'
        ? args.listing.id
        : args.listing,
    }

    return reviews.definition.url
            .replace('{listing}', parsedArgs.listing.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ReviewController::reviews
* @see app/Http/Controllers/ReviewController.php:60
* @route '/admin/listings/{listing}/reviews'
*/
reviews.get = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reviews.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReviewController::reviews
* @see app/Http/Controllers/ReviewController.php:60
* @route '/admin/listings/{listing}/reviews'
*/
reviews.head = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: reviews.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ReviewController::reviews
* @see app/Http/Controllers/ReviewController.php:60
* @route '/admin/listings/{listing}/reviews'
*/
const reviewsForm = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reviews.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReviewController::reviews
* @see app/Http/Controllers/ReviewController.php:60
* @route '/admin/listings/{listing}/reviews'
*/
reviewsForm.get = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reviews.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReviewController::reviews
* @see app/Http/Controllers/ReviewController.php:60
* @route '/admin/listings/{listing}/reviews'
*/
reviewsForm.head = (args: { listing: string | number | { id: string | number } } | [listing: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reviews.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

reviews.form = reviewsForm

const listings = {
    index: Object.assign(index, index),
    export: Object.assign(exportMethod, exportMethod),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    situation: Object.assign(situation, situation),
    galleryOrder: Object.assign(galleryOrder, galleryOrder),
    destroy: Object.assign(destroy, destroy),
    media: Object.assign(media, media),
    statusData: Object.assign(statusData, statusData),
    updateStatus: Object.assign(updateStatus, updateStatus),
    reviews: Object.assign(reviews, reviews),
}

export default listings